import type { CSSProperties } from 'react';
import * as styles from './Skeleton.module.scss';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'rectangular' | 'circular';
  animation?: 'pulse' | 'wave' | 'none';
  className?: string;
  style?: CSSProperties;
}

const Skeleton = ({
  width,
  height,
  variant = 'text',
  animation = 'pulse',
  className,
  style,
}: SkeletonProps) => {
  const classNames = `
    ${styles.skeleton}
    ${styles[variant]}
    ${styles[`animation_${animation}`]}
    ${className}
  `.trim();

  const inlineStyles = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    ...style,
  };

  return <div className={classNames} style={inlineStyles} data-testid="skeleton" />;
};

export default Skeleton;
